/**
 * KM newsletter / footer newsletter: friendlier HTML5 validation message for required marketing consent checkbox.
 */
(function () {
  function bind(container) {
    if (container.hasAttribute('data-km-nl-consent-bound')) return;
    container.setAttribute('data-km-nl-consent-bound', '');

    var hint = container.getAttribute('data-km-nl-consent-hint');
    if (!hint) return;

    var cb = container.querySelector('[data-km-marketing-consent]');
    if (!cb) return;

    cb.addEventListener('invalid', function () {
      if (!cb.checked) {
        cb.setCustomValidity(hint);
      }
    });

    cb.addEventListener('change', function () {
      cb.setCustomValidity('');
    });
  }

  function init() {
    document.querySelectorAll('[data-km-nl-consent-form]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
